import React, { useEffect, useMemo, useState } from "react";

import { Typography, Modal } from "antd";
import { Button } from "components/Buttons/Buttons";
import {
  isCancellationPolicyApplicable,
  updateOrderStatus,
  cancelOrder,
  getBookingDetails,
} from "services/booking.service";
import { useDispatch } from "react-redux";
import { setCurrentBooking } from "redux/actions/booking.actions";
import { CloseCircleOutlined } from "@ant-design/icons";
import ReasonModal from "components/ReasonModal";
import Spinner from "components/Spinner/Spinner";
import { FormCheckbox } from "components/FormItems/FlatFormItems";

const { Text } = Typography;

export default function CancelButton({ booking, getData }) {
  const { orderStatus, orderId } = booking;
  const isOrderCompleted = orderStatus === 3;

  const dispatch = useDispatch();

  const [showCancellationReasonPopup, setShowCancellationReasonPopup] = useState(false)
  const [orderCancellationFeeInfo, setOrderCancellationFeeInfo] = useState({
    isCancelFeeApplicable: false,
    isFetching: false,
    isFetched: false,
  })

  async function loadOrderCancellationFeeInfo() {
    setOrderCancellationFeeInfo(state => ({
      ...state,
      isFetching: true
    }))
    let response = await checkIsCancelFeeApplicable();
    if (response?.status === 'success') {
      let isCancelFeeApplicable = response.data;
      setOrderCancellationFeeInfo({
        isCancelFeeApplicable,
        isFetching: false,
        isFetched: true
      })
    }
  }

  const orderCancellationFeePopupText = useMemo(() => {
    if (orderCancellationFeeInfo.isFetching) {
      return <Spinner />
    } else if (orderCancellationFeeInfo.isCancelFeeApplicable) {
      return "Cancellation Fee is aplicable on this order."
    } else if (orderCancellationFeeInfo.isCancelFeeApplicable === false) {
      return "Cancellation Fee is not aplicable on this order."
    }
  }, [orderCancellationFeeInfo])

  async function checkIsCancelFeeApplicable() {
    return dispatch(isCancellationPolicyApplicable(orderId));
  }

  async function processOrderCancellation({ note = "", shouldChargeCancellationFee = false }) {
    await dispatch(cancelOrder(booking, shouldChargeCancellationFee, note));
    if (getData) getData();
    else {
      // refresh the booking details
      dispatch(
        getBookingDetails(booking.orderId, (booking) => {
          dispatch(setCurrentBooking(booking));
        })
      );
    }
  }



  return (
    <>
      {orderStatus === 2 ? (
        <Text style={{ color: "#ca2727" }}>Cancelled</Text>
      ) : (
        <>
          <Button
            className="btn-danger"
            rounded
            disabled={isOrderCompleted}
            style={{
              height: 50,
            }}
            onClick={async () => {
              if (orderCancellationFeeInfo.isFetched === false)
                loadOrderCancellationFeeInfo()
              setShowCancellationReasonPopup(true)
              // handleCancel();
            }}
          >
            Cancel
          </Button>
          <ReasonModal
            title="Order Cancellation"
            visible={showCancellationReasonPopup}
            text={orderCancellationFeePopupText}
            onCancel={() => setShowCancellationReasonPopup(false)}
            isFetching={orderCancellationFeeInfo.isFetching}
            labelForTextArea="Reason"
            onSave={processOrderCancellation}
          >
            {
              orderCancellationFeeInfo.isCancelFeeApplicable &&
              <FormCheckbox
                name="shouldChargeCancellationFee"
                initialValue={true}
                formItemStyles={{
                  marginBottom: 0
                }}
                className={"boldCheckbox"}
              >
                Do you want to charge fee?
              </FormCheckbox>
            }
          </ReasonModal>
        </>
      )}

    </>
  );
}
